export const REACT_APP_RTK_DEVTOOLS_STATE = process.env.REACT_APP_RTK_DEVTOOLS_STATE === "enabled" ? true : false
    /**
         * !warn
         * this is a temporary change for pricing matrix
        */
export const PUBLIC_USER = process.env.REACT_APP_PUBLIC_USER_ID
